import { Typography, Box } from '@mui/material';
import React from 'react';
import { Main } from '../../components';

const Developers: React.FC = () => {
    return (
        <Main active={2}>
            <Box sx={{ py: 2 }}>
                <Typography variant="h5">Embedded Mode</Typography>
                <Typography variant="caption" sx={{ display: 'block', mb: 3 }}>
                    Header and author captions will be hidden in embedded mode.
                </Typography>
                <Box
                    sx={{
                        fontSize: '.8rem',
                        py: 2,
                        px: 0.5,
                        backgroundColor: '#fafafa',
                    }}
                    component="code"
                >
                    query param (not mandatory): ?embedded=true
                </Box>
            </Box>
        </Main>
    );
};

export default Developers;
